import { Flex } from "antd";
import { FC } from "react";

import BaseButton from "@/shared/ui/BaseButton";
import { BaseModal } from "@/shared/ui/BaseModal";
import { SecondaryText } from "@/shared/ui/Typography";

interface ConfirmModalProps {
    open: boolean;
    loading: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
    open,
    onClose,
    onConfirm,
    loading,
}) => {
    const handleClose = () => {
        if (loading) return;
        onClose();
    };

    return (
        <BaseModal
            title="Ви впевнені?"
            open={open}
            onClose={handleClose}
            actions={null}
            mask={{ closable: !loading }}
        >
            <SecondaryText textAlign="center">
                Внести нові зміни можливо буде лише при підтверджені
                Супервайзером
            </SecondaryText>

            <Flex vertical gap={8}>
                <BaseButton
                    type="primary"
                    onClick={onConfirm}
                    loading={loading}
                >
                    Підтвердити
                </BaseButton>

                <BaseButton
                    type="default"
                    onClick={handleClose}
                    disabled={loading}
                >
                    Повернутися назад
                </BaseButton>
            </Flex>
        </BaseModal>
    );
};
